import modal from './Modal';
export default modal;
